// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* blanco #dddddd */
/* oscuro #414141*/
:root {
  --main-color: #15243E;
  --white-color:#F5F7FB;
  --main-shadow-color:#0c1524;
}


  .sidebar {
    width: 15%;
    background-color: var(--main-color);
    /* background: linear-gradient(90deg, rgba(255,254,255,1) 0%, rgba(195,195,195,1) 100%); */
    position: absolute;
    height: 95%;
    display: inline;
    transition: width 0.3s ease;
    z-index: 3;
  }
  .contSiders{
    position: relative;
    width:100%;
    height: 100%;
    display: block;
  }
  .sidebarDark {
    width: 12%;
    background-color: var(--white-color);
    /* background: linear-gradient(90deg, rgba(255,254,255,1) 0%, rgba(195,195,195,1) 100%); */
    position: absolute;
    height: 100px;
    height: 95%;
    display: inline;
    transition: width 0.3s ease;
    z-index: 2;
  }
  .sidebarHeader{
    position: relative;
    height: 5%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sidebarBody{
    position: relative;
    height: 85%;
    width: 100%;
    display: block;
    overflow: auto;
  }
  .sidebarFooter{
    position: relative;
    height: 10%;
    width: 100%;
    display: block;
  }
  .sideLogo{
    position: absolute;
    bottom: 2%;
    height: 10%;
    width: 100%;
    display: flex;
    justify-content: center;
  }
.sidebar:hover .icon-seguritech{
    transform: rotate(15deg);
    transition: ease-in-out;
    cursor: pointer;
}
.sidebar:hover .sidebarCont{
    justify-content: center;
    cursor: pointer;
}
/* .sidebarWhite:hover .icon-seguritech{
  transform: rotate(15deg);
  transition: ease-in-out;
  cursor: pointer;
} */
.sidebarDark:hover .sidebarContDark{
  justify-content: center;
  cursor: pointer;
}
.sidebarCont:hover{
  background: var(--main-shadow-color);
  border-radius: 5px;
  /* transform:scale(1.1); */
}
.sidebarCont:hover .textSideCont {
  font-size: var(--font-size-small) !important;
  /* color: red; */
  /* transform:scale(1.1);  */
}
.btnLogout:hover{
  background: #c2c2c248;
  cursor: pointer;
}
.sidebarContDark:hover{
  background: var(--hover-color);
  border-radius: 5px;
  transform:scale(1.1);
}
.sideSelected:hover{
  background: var(--main-shadow-color);
  /* transform:scale(1.1); */
  color: #fff !important;
}
.sideSelected{
  background: var(--main-shadow-color);
  border-radius: 5px;
  color: #fff !important;
}
.sideSelectedWhite:hover{
  background: #c4c4c4;
  transform:scale(1.1);
  color: #012c44 !important;
}
.sideSelectedWhite{
  background: #eee;
  border-radius: 5px;
  color: #012c44 !important;
}

/* .sidebar:hover{
    width: 10%;
    z-index: 3;
    transition: width 0.3s ease;
} */
.sidebarWhite:hover{
  width: 10%;
  z-index: 3;
  background-color: #003757;
  transition: width 0.3s ease;
}
  .sideLogo img{
    height: 100%;
  }
  .sidebarCont{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */
    width: 90%;
    height: 70%;
    transition: width 0.3s ease;
    color: var(--white-color);
    
  }
  .sidebarContDark{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */
    width: 90%;
    height: 70%;
    transition: width 0.3s ease;
    color: var(--main-color);
    
  }
  .sideRowSelected{
    background: var(--main-shadow-color);
  }
  .sideRowSelectedDark{
    background: var(--txt-color-low);
  }
  .sidebarRow{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid gray; */
    width: 100%;
    height: 5%;
    transition: width 0.3s ease;
    /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */
  }
  /* .textSideCont{
    display: none;
    letter-spacing: 1px;
    font-size: smaller;
    width: 70%;
    height: 100%;
    transition: width 0.3s ease;
  } */
  .textSideCont{
    display: flex;
    justify-content: start;
    align-items: center;
    letter-spacing: 1px;
    font-size:var(--font-size-small);
    width: 70%;
    height: 100%;
    transition: width 0.3s ease;
  }
  /* .sidebar:hover .textSideCont{
    display: flex;
    justify-content: center;
    align-items: center;
    transition: width 0.3s ease;
} */
.sidebar:hover .imgSideCont{
  display: flex;
  width: 30%;
  transition: width 0.3s ease;
}
/* .sidebarWhite:hover .textSideCont{
  display: flex;
  justify-content: center;
  align-items: center;
  transition: width 0.3s ease;
} */
.sidebarDark:hover .imgSideCont{
display: flex;
width: 30%;
transition: width 0.3s ease;
}
.imgSideCont{
  width: 30%;
  height: 100%;
  display: flex;
  justify-content: center;
  transition: width 0.3s ease;
}
.imgSideCont img{ 
transform: scale(0.8);
}
.txtEstadoDark{
  color: var(--main-color);
}
.txtEstado{
  color: var(--white-color);
}
/******************************side option************************/
.desplegado{
  height: auto;
  width: 100%;
  background: var(--main-shadow-color);
  display: block;
  /* max-height: 200px;
  /* /* overflow: auto; */
  
}
.submodulos{
  background-color: var(--third-color);
}
.submodulos .sideSelected{
  background-color: var(--third-color);
}
.sidebarRowsub {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-xSmall);
  /* border: 1px solid gray; */
  width: 100%;
  height: 30px;
  transition: width 0.3s ease;
  /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */
}
.sidebarRowDoubleSub {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-xSmall);
  /* border: 1px solid gray; */
  width: 100%;
  min-height: 30px;
  height: auto;
  transition: width 0.3s ease;
  /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */
}
.contArrowSelected{
  position: absolute;
  height: 100%;
  width: 15%;
 display: flex;
 justify-content: center;
 align-items: center;
  right: 0%;
}
.contArrowSelected img{
  width: 40%;
}

.menu-icon-sidebar{
  display: none;
}

/* ****************************Movil****************************** */
@media (max-width: 500px) {
  .sidebar  {
     height: 5%;
     width: 100%;
  }
  .sidebar.menumovilOpen {
    height: 90% !important;
    /* width: 100%; */
 }
 
  .menu-icon-sidebar{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--white-color);
    font-size: 16px;
  }
  .menu-icon-sidebar:hover{
    font-size: 20px;
    cursor: pointer;
  }
  .menu-icon-sidebar.menumovilOpen{
    height: 5%;
  }
   .contSiders.menumovil{
    display: none;
  }
   .contSiders.menumovilOpen{
    display: block;
  }
  .sidebarBody{
    height: 80%;
  }
  .sidebarRow{
    height: 6%;
  }
  .sidebarRow {
    height: 6%;
  }
  .desplegado{
    height: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/SideBar.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB,kBAAkB;AAClB;EACE,qBAAqB;EACrB,qBAAqB;EACrB,2BAA2B;AAC7B;;;EAGE;IACE,UAAU;IACV,mCAAmC;IACnC,0FAA0F;IAC1F,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,cAAc;EAChB;EACA;IACE,UAAU;IACV,oCAAoC;IACpC,0FAA0F;IAC1F,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;IACd,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;AACF;IACI,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;AACnB;AACA;IACI,uBAAuB;IACvB,eAAe;AACnB;AACA;;;;GAIG;AACH;EACE,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;GAIG;AACH;EACE,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,2BAA2B;AAC7B;EACE;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qDAAqD;IACrD,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;;EAE3B;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qDAAqD;IACrD,UAAU;IACV,WAAW;IACX,2BAA2B;IAC3B,wBAAwB;;EAE1B;EACA;IACE,oCAAoC;EACtC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,4BAA4B;IAC5B,WAAW;IACX,UAAU;IACV,2BAA2B;IAC3B,qDAAqD;EACvD;EACA;;;;;;;KAOG;EACH;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;IAChC,UAAU;IACV,YAAY;IACZ,2BAA2B;EAC7B;EACA;;;;;GAKC;AACH;EACE,aAAa;EACb,UAAU;EACV,2BAA2B;AAC7B;AACA;;;;;GAKG;AACH;AACA,aAAa;AACb,UAAU;AACV,2BAA2B;AAC3B;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;AACA,qBAAqB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA,kEAAkE;AAClE;EACE,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,cAAc;EACd;yBACuB;;AAEzB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,qDAAqD;AACvD;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;CACX,aAAa;CACb,uBAAuB;CACvB,mBAAmB;EAClB,SAAS;AACX;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA,oEAAoE;AACpE;EACE;KACG,UAAU;KACV,WAAW;EACd;EACA;IACE,sBAAsB;IACtB,iBAAiB;CACpB;;EAEC;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;EACjB;EACA;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,UAAU;EACZ;GACC;IACC,aAAa;EACf;GACC;IACC,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* blanco #dddddd */\r\n/* oscuro #414141*/\r\n:root {\r\n  --main-color: #15243E;\r\n  --white-color:#F5F7FB;\r\n  --main-shadow-color:#0c1524;\r\n}\r\n\r\n\r\n  .sidebar {\r\n    width: 15%;\r\n    background-color: var(--main-color);\r\n    /* background: linear-gradient(90deg, rgba(255,254,255,1) 0%, rgba(195,195,195,1) 100%); */\r\n    position: absolute;\r\n    height: 95%;\r\n    display: inline;\r\n    transition: width 0.3s ease;\r\n    z-index: 3;\r\n  }\r\n  .contSiders{\r\n    position: relative;\r\n    width:100%;\r\n    height: 100%;\r\n    display: block;\r\n  }\r\n  .sidebarDark {\r\n    width: 12%;\r\n    background-color: var(--white-color);\r\n    /* background: linear-gradient(90deg, rgba(255,254,255,1) 0%, rgba(195,195,195,1) 100%); */\r\n    position: absolute;\r\n    height: 100px;\r\n    height: 95%;\r\n    display: inline;\r\n    transition: width 0.3s ease;\r\n    z-index: 2;\r\n  }\r\n  .sidebarHeader{\r\n    position: relative;\r\n    height: 5%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .sidebarBody{\r\n    position: relative;\r\n    height: 85%;\r\n    width: 100%;\r\n    display: block;\r\n    overflow: auto;\r\n  }\r\n  .sidebarFooter{\r\n    position: relative;\r\n    height: 10%;\r\n    width: 100%;\r\n    display: block;\r\n  }\r\n  .sideLogo{\r\n    position: absolute;\r\n    bottom: 2%;\r\n    height: 10%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n.sidebar:hover .icon-seguritech{\r\n    transform: rotate(15deg);\r\n    transition: ease-in-out;\r\n    cursor: pointer;\r\n}\r\n.sidebar:hover .sidebarCont{\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n/* .sidebarWhite:hover .icon-seguritech{\r\n  transform: rotate(15deg);\r\n  transition: ease-in-out;\r\n  cursor: pointer;\r\n} */\r\n.sidebarDark:hover .sidebarContDark{\r\n  justify-content: center;\r\n  cursor: pointer;\r\n}\r\n.sidebarCont:hover{\r\n  background: var(--main-shadow-color);\r\n  border-radius: 5px;\r\n  /* transform:scale(1.1); */\r\n}\r\n.sidebarCont:hover .textSideCont {\r\n  font-size: var(--font-size-small) !important;\r\n  /* color: red; */\r\n  /* transform:scale(1.1);  */\r\n}\r\n.btnLogout:hover{\r\n  background: #c2c2c248;\r\n  cursor: pointer;\r\n}\r\n.sidebarContDark:hover{\r\n  background: var(--hover-color);\r\n  border-radius: 5px;\r\n  transform:scale(1.1);\r\n}\r\n.sideSelected:hover{\r\n  background: var(--main-shadow-color);\r\n  /* transform:scale(1.1); */\r\n  color: #fff !important;\r\n}\r\n.sideSelected{\r\n  background: var(--main-shadow-color);\r\n  border-radius: 5px;\r\n  color: #fff !important;\r\n}\r\n.sideSelectedWhite:hover{\r\n  background: #c4c4c4;\r\n  transform:scale(1.1);\r\n  color: #012c44 !important;\r\n}\r\n.sideSelectedWhite{\r\n  background: #eee;\r\n  border-radius: 5px;\r\n  color: #012c44 !important;\r\n}\r\n\r\n/* .sidebar:hover{\r\n    width: 10%;\r\n    z-index: 3;\r\n    transition: width 0.3s ease;\r\n} */\r\n.sidebarWhite:hover{\r\n  width: 10%;\r\n  z-index: 3;\r\n  background-color: #003757;\r\n  transition: width 0.3s ease;\r\n}\r\n  .sideLogo img{\r\n    height: 100%;\r\n  }\r\n  .sidebarCont{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */\r\n    width: 90%;\r\n    height: 70%;\r\n    transition: width 0.3s ease;\r\n    color: var(--white-color);\r\n    \r\n  }\r\n  .sidebarContDark{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */\r\n    width: 90%;\r\n    height: 70%;\r\n    transition: width 0.3s ease;\r\n    color: var(--main-color);\r\n    \r\n  }\r\n  .sideRowSelected{\r\n    background: var(--main-shadow-color);\r\n  }\r\n  .sideRowSelectedDark{\r\n    background: var(--txt-color-low);\r\n  }\r\n  .sidebarRow{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    /* border: 1px solid gray; */\r\n    width: 100%;\r\n    height: 5%;\r\n    transition: width 0.3s ease;\r\n    /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */\r\n  }\r\n  /* .textSideCont{\r\n    display: none;\r\n    letter-spacing: 1px;\r\n    font-size: smaller;\r\n    width: 70%;\r\n    height: 100%;\r\n    transition: width 0.3s ease;\r\n  } */\r\n  .textSideCont{\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n    letter-spacing: 1px;\r\n    font-size:var(--font-size-small);\r\n    width: 70%;\r\n    height: 100%;\r\n    transition: width 0.3s ease;\r\n  }\r\n  /* .sidebar:hover .textSideCont{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    transition: width 0.3s ease;\r\n} */\r\n.sidebar:hover .imgSideCont{\r\n  display: flex;\r\n  width: 30%;\r\n  transition: width 0.3s ease;\r\n}\r\n/* .sidebarWhite:hover .textSideCont{\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  transition: width 0.3s ease;\r\n} */\r\n.sidebarDark:hover .imgSideCont{\r\ndisplay: flex;\r\nwidth: 30%;\r\ntransition: width 0.3s ease;\r\n}\r\n.imgSideCont{\r\n  width: 30%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  transition: width 0.3s ease;\r\n}\r\n.imgSideCont img{ \r\ntransform: scale(0.8);\r\n}\r\n.txtEstadoDark{\r\n  color: var(--main-color);\r\n}\r\n.txtEstado{\r\n  color: var(--white-color);\r\n}\r\n/******************************side option************************/\r\n.desplegado{\r\n  height: auto;\r\n  width: 100%;\r\n  background: var(--main-shadow-color);\r\n  display: block;\r\n  /* max-height: 200px;\r\n  /* /* overflow: auto; */\r\n  \r\n}\r\n.submodulos{\r\n  background-color: var(--third-color);\r\n}\r\n.submodulos .sideSelected{\r\n  background-color: var(--third-color);\r\n}\r\n.sidebarRowsub {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: var(--font-size-xSmall);\r\n  /* border: 1px solid gray; */\r\n  width: 100%;\r\n  height: 30px;\r\n  transition: width 0.3s ease;\r\n  /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */\r\n}\r\n.sidebarRowDoubleSub {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: var(--font-size-xSmall);\r\n  /* border: 1px solid gray; */\r\n  width: 100%;\r\n  min-height: 30px;\r\n  height: auto;\r\n  transition: width 0.3s ease;\r\n  /* border-bottom: 3px solid rgba(84, 84, 84, 0.34); */\r\n}\r\n.contArrowSelected{\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 15%;\r\n display: flex;\r\n justify-content: center;\r\n align-items: center;\r\n  right: 0%;\r\n}\r\n.contArrowSelected img{\r\n  width: 40%;\r\n}\r\n\r\n.menu-icon-sidebar{\r\n  display: none;\r\n}\r\n\r\n/* ****************************Movil****************************** */\r\n@media (max-width: 500px) {\r\n  .sidebar  {\r\n     height: 5%;\r\n     width: 100%;\r\n  }\r\n  .sidebar.menumovilOpen {\r\n    height: 90% !important;\r\n    /* width: 100%; */\r\n }\r\n \r\n  .menu-icon-sidebar{\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: var(--white-color);\r\n    font-size: 16px;\r\n  }\r\n  .menu-icon-sidebar:hover{\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n  }\r\n  .menu-icon-sidebar.menumovilOpen{\r\n    height: 5%;\r\n  }\r\n   .contSiders.menumovil{\r\n    display: none;\r\n  }\r\n   .contSiders.menumovilOpen{\r\n    display: block;\r\n  }\r\n  .sidebarBody{\r\n    height: 80%;\r\n  }\r\n  .sidebarRow{\r\n    height: 6%;\r\n  }\r\n  .sidebarRow {\r\n    height: 6%;\r\n  }\r\n  .desplegado{\r\n    height: auto !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
